import GetDetail from "./GetDetail";
import Create from "./Create";
import Update from "./Update";
import GetAll from "./GetAll";

export default [...Create, ...Update, ...GetDetail, ...GetAll];
